import React, { useState } from "react";
import { Row, Col, Segmented, Input, Card, Collapse } from "antd";
import { SupportPageWrapper } from "./styled";
import {
  CustomTitle,
  CustomSubTitle,
  CustomButton,
  CustomSecondaryButton,
} from "../physician_page/styled";
import {
  FileTextOutlined,
  VideoCameraOutlined,
  QuestionCircleOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import { CiPlay1, CiSearch } from "react-icons/ci";
import { FaAngleDown, FaAngleUp } from "react-icons/fa6";
import Navbar from "../home/Navbar";
import { faqData } from "./FAQ";

const { Panel } = Collapse;

const SupportPage = () => {
  const [selectedTab, setSelectedTab] = useState("Video Tutorials");
  const [faqList, setFaqList] = useState(faqData?.FAQ);

  return (
    <>
    {/* <Navbar /> */}
      <SupportPageWrapper style={{ padding: "30px 60px" }}>
        <Row className="custom-header">
          <Col className="header-item">
            <CustomTitle style={{ fontSize: "32px" }}>
              Help Center
            </CustomTitle>
            <CustomSubTitle>
              Get help with using the Meducate platform through articles,
              videos, and documentation.
            </CustomSubTitle>
          </Col>
        </Row>
        <Row className="w-100 d-lex justify-content-center mt-25">
          <Col className="d-flex justify-content-center">
           <CiSearch className="support-search-icon text-primary" />
            <Input
              placeholder="Search for help articles"
              className="custom-search-box"
            />
            <CustomButton className="search-icon">Search</CustomButton>
          </Col>
        </Row>
        <Row gutter={[16]} className="mt-30 mb-50">
          <Col span={8}>
            <Card >
              <Col className="d-flex mb-4 justify-start gap-12">
                <div>
                  <FileTextOutlined className="font-19 custom-faq-icon-color" />
                </div>
                <div className="font-24 font-semibold">
                  Articles
                </div>
              </Col>
              <Col className="font-15 mb-15">
                Step-by-step guides and how-to articles to help you use Meducate
                effectively.
              </Col>
              <Col className="font-16 font-semibold">
                Browse Articles
              </Col>
            </Card>
          </Col>
          <Col span={8}>
            <Card className="support-custom-cards">
              <Col className="d-flex mb-4 justify-start gap-12">
                <div>
                  <VideoCameraOutlined className="font-19 custom-faq-icon-color" />
                </div>
                <div className="font-24 font-semibold">
                  Video Tutorials
                </div>
              </Col>
              <Col className="font-15 mb-15">
                Watch video tutorials to learn how to use the platform's
                features.
              </Col>
              <Col className="font-16 font-semibold">
                Watch Tutorials
              </Col>
            </Card>
          </Col>
          <Col span={8}>
            <Card className="support-custom-cards">
              <Col className="d-flex mb-4 justify-start gap-12">
                <div>
                  <QuestionCircleOutlined className="font-19 custom-faq-icon-color" />
                </div>
                <div className="font-24 font-semibold">FAQs</div>
              </Col>
              <Col className="font-15 mb-15">
                Find answers to commonly asked questions about the platform.
              </Col>
              <Col className="font-16 font-semibold">
                View FAQs
              </Col>
            </Card>
          </Col>
        </Row>
        <Row className="w-100" style={{ padding: "25px 0" }}>
          <Segmented
            className="w-100"
            options={["Video Tutorials", "FAQs", "Documents"]}
            block
            value={selectedTab}
            onChange={(value) => setSelectedTab(value)}
          />
        </Row>

        {/* {selectedTab === "Articles" && (
          <Row gutter={[24, 24]}>
            {[...Array(9)].map((_, i) => (
              <Col span={8}>
                <Card>
                  <Col
                    className="d-flex mb-15"
                    style={{ justifyContent: "space-between" }}
                  >
                    <div className="font-semibold article-card-tag">
                      Getting Started
                    </div>
                    <div className="">5 min read</div>
                  </Col>
                  <Col className="d-flex mb-15 justify-start gap-12">
                    <div className="font-18 font-semibold ">
                      Getting Started with Meducate
                    </div>
                  </Col>
                  <Col className="font-15 mb-4">
                    Learn the basics of navigating the Meducate platform and
                    setting up your account.
                  </Col>
                  <Col
                    className="font-16 font-semibold"
                    style={{ color: "#8a3ef4" }}
                  >
                    Read Article
                  </Col>
                </Card>
              </Col>
            ))}
            <Col className="w-100 d-flex justify-content-center">
              <CustomSecondaryButton>Load More Articles</CustomSecondaryButton>
            </Col>
          </Row>
        )} */}

        {selectedTab === "Video Tutorials" && (
          <Row gutter={[24, 24]}>
            {[...Array(6)].map((_, i) => (
              <Col span={8}>
                <Card
                  key={i}
                  cover={
                    <img
                      alt="example"
                      src="https://gw.alipayobjects.com/zos/rmsportal/JiqGstEfoWAOHiTxclqi.png"
                    />
                  }
                >
                  <Col className="font-18 font-semibold mb-10">
                    <div>Platform Overview</div>
                  </Col>
                  <Col className="font-15 mb-10">
                    A complete tour of the Meducate platform and its key
                    features.
                  </Col>
                  <Col className="d-flex justify-start custom-videoplay-icon">
                    <CiPlay1 size={19} />
                    Watch Tutorial
                  </Col>
                </Card>
              </Col>
            ))}
            <Col className="w-100 d-flex justify-content-center">
              <CustomSecondaryButton>View All Tutorials</CustomSecondaryButton>
            </Col>
          </Row>
        )}

        {selectedTab === "FAQs" && (
          <Row className="w-100 mt-50">
            <Col className="w-100">
              <Card style={{ padding: "10px" }}>
                <Col className="mb-24">
                  <div className="font-23 font-semibold">
                    Frequently Asked Questions
                  </div>
                  <div className="font-15">
                    Find answers to common questions about using Meducate.
                  </div>
                </Col>
                {faqList.map((item)=> (
                <Col>
                  <Collapse
                    bordered={false}
                    expandIconPosition="end"
                    expandIcon={({ isActive }) =>
                      isActive ? (
                        <FaAngleUp className="faq-expand-icon" />
                      ) : (
                        <FaAngleDown className="faq-expand-icon" />
                      )
                    }
                  >
                    <Panel header={item.question} key={item.id}>
                      <p>
                        {item.answer}
                      </p>
                    </Panel>
                  </Collapse>
                </Col>
                ))}
              </Card>
            </Col>
          </Row>
        )}

        {selectedTab === "Documents" && (
          <Row className="w-100">
            <Col className="w-100">
              <Card style={{ padding: "10px" }}>
                <Col className="mb-24">
                  <div className="font-23 font-semibold">
                    Documentation & Resources
                  </div>
                  <div className="font-15">
                    Download guides, templates, and other resources.
                  </div>
                </Col>
                <Col>
                  <Card type="inner" className="mb-10">
                    <Row
                      className="d-flex"
                      style={{ justifyContent: "space-between" }}
                    >
                      <Col className="d-flex gap-12">
                        <div>
                          <FileTextOutlined className="document-card-icon" />
                        </div>
                        <div>
                          <div className="font-17 font-semibold">
                            User Manual
                          </div>
                          <div className="font-15">
                            Complete guide to using the Meducate platform
                          </div>
                        </div>
                      </Col>
                      <Col>
                        <CustomSecondaryButton>
                          <DownloadOutlined className="font-20" />
                          Download PDF
                        </CustomSecondaryButton>
                      </Col>
                    </Row>
                  </Card>
                  <Card type="inner">
                    <Row
                      className="d-flex"
                      style={{ justifyContent: "space-between" }}
                    >
                      <Col className="d-flex gap-12">
                        <div>
                          <FileTextOutlined className="document-card-icon" />
                        </div>
                        <div>
                          <div className="font-17 font-semibold">
                            Administrator Guide
                          </div>
                          <div className="font-15">
                            Detailed guide for platform administrators
                          </div>
                        </div>
                      </Col>
                      <Col>
                        <CustomSecondaryButton>
                          <DownloadOutlined className="font-20" />
                          Download PDF
                        </CustomSecondaryButton>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              </Card>
            </Col>
          </Row>
        )}

        <Row className="w-100 mt-50">
          <Col className="w-100">
            <Card style={{ padding: "10px" }}>
              <Col className="mb-24">
                <div className="font-24 font-semibold">
                  Need More Help?
                </div>
                <div className="font-15">
                  Our support team is available to assist you with any questions
                  or issues.
                </div>
              </Col>
              <Col className="row-flex" style={{ gap: "20px" }}>
                <div className="custom-support-box">
                  <h2 className="font-19 font-semibold text-primary">
                    Contact Support
                  </h2>
                  <p className="font-15">
                    Our support team is available Monday through Friday, 9am-5pm
                    ET.
                  </p>
                  <CustomButton className="w-100">
                    Submit a Support Ticket
                  </CustomButton>
                </div>
                <div className="custom-support-box">
                  <h2 className="font-19 font-semibold text-primary">
                    Schedule a Training
                  </h2>
                  <p className="font-15">
                    Book a one-on-one training session with our product
                    specialists.
                  </p>
                  <CustomSecondaryButton className="w-100">
                    Schedule Training
                  </CustomSecondaryButton>
                </div>
              </Col>
            </Card>
          </Col>
        </Row>
      </SupportPageWrapper>
    </>
  );
};

export default SupportPage;
